/**
 * TODOS JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
import aon_craft_utils from './aon_craft_utils.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Todos UI, data
         * UI interaction functions
         */
        //console.log( 'Todos widget - init' );
        
        // Variable to contain todo entries
        this.aon_todos_entries = []; 
        
        // Render Todos...
        this.renderTodos();
        
        /*
         * Add / Edit Modal interaction...
         */
        
        var todos_add_edit_modal_mode = '';
        
        // Click to Edit existing calendar entry modal link...
        $( 'body' ).on( 'click', '.todos_entry a', function( event ) {
            todos_add_edit_modal_mode = 'edit';
            var name = $( this ).text();
            var status = $( this ).attr( 'data-todos-entry-status' );
            var id = $( this ).attr( 'data-todos-array-id' );
            var postid = $( this ).attr( 'data-todos-postid' );
            $( '#todos_add_edit_entry_modal #todos_entry_title_field' ).val( name );
            $( '#todos_add_edit_entry_modal #todos_entry_status' ).val( status );
            $( '#todos_add_edit_entry_modal #todos_array_id' ).val( id );
            $( '#todos_add_edit_entry_modal #todos_postid' ).val( postid );
            
            //console.log( 'Start opening Todos Modal...');
            openTodosModal();
            //console.log( 'Done opening Todos Modal...');
            
            event.preventDefault();
        });
        
        var openTodosModal = () => { // Function defined using arrow method to gain access to main 'this'
            // Open specific modal depending on whether we're adding / editing entries or setting activity types
            //console.log( 'Called opening Todos Modal...');
            $( '#todos_add_edit_entry_modal' ).foundation( 'open' );
        }
        

        // Click on Add Todo entry modal link...
        $( 'body' ).on( 'click', '.todos_entry_add_edit', function( event ) {
            todos_add_edit_modal_mode = 'add';
            openTodosModal();
            event.preventDefault();
        });

        // 'Save' button click within Todos entry modal...
        $( 'body' ).on( 'click', '#save_todos_entry', function( event ) {
            // Save data to existing
            var id = $( '#todos_add_edit_entry_modal #todos_array_id' ).val();
            var postid = $( '#todos_add_edit_entry_modal #todos_postid' ).val();
            var name = $( '#todos_add_edit_entry_modal #todos_entry_title_field' ).val();
            var status = $( '#todos_add_edit_entry_modal #todos_entry_status' ).val();
            if ( todos_add_edit_modal_mode == 'edit' ) {
                // Update existing entry to entries array - if req values all complete...
                if ( id != '' && postid != '' && name != '' ) {
                    saveExistingTodosEntry( id, postid, name, status );
                }
            } else if ( todos_add_edit_modal_mode == 'add' ) {
                // Add new entry to entries array - if req values all complete...
                if ( name != '' ) {
                    // !! THE 'postid' WOULD BE GENERATED ON CREATION OF THE
                    // !! NEW POST IN THE BACKEND, USING '0' AS A DUMMY ONE FOR NOW,
                    // !! ENSURE PROPER CODE USES GENERATED 'postid' !!
                    saveNewTodosEntry( '0', name, 'active' );
                    //saveNewTodosEntry( postid, name, 'active' );
                }
            } else if ( todos_add_edit_modal_mode == 'delete' ) {
                // Delete...
                if ( postid != '' ) {
                    deletingExistingTodosEntry( id, postid, name, status );
                }
            }
            
            event.preventDefault();
        });
        
        // 'Completed / Active' status button click within Todos entry...
        $( 'body' ).on( 'click', 'button.status', function( event ) {
            // Save data to existing
            //var id = $( '#todos_add_edit_entry_modal #todos_array_id' ).attr( 'data-todos-postid' );
            var id = $( this ).siblings( 'a' ).attr( 'data-todos-array-id' );
            var postid = $( this ).siblings( 'a' ).attr( 'data-todos-postid' );
            var name = $( this ).siblings( 'a' ).text();
            var status = $( this ).siblings( 'a' ).attr( 'data-todos-entry-status' );
            //console.log( postid + ' - ' + name + ' - ' + status );
            if ( id != '' && postid != '' && name != '' && status != '' ) {
                if ( $( this ).hasClass( 'active' ) ) {
                    //toggleTodoStatus( id, 'completed' );
                    saveTodosEntryStatus( id, postid, name, 'completed' );

                } else if ( $( this ).hasClass( 'completed' ) ) {
                    //toggleTodoStatus( id, 'active' );
                    saveTodosEntryStatus( id, postid, name, 'active' );
                }
            }
            
            event.preventDefault();
        });
        
        var saveTodosEntryStatus = ( id, postid, name, status ) => {
            this.saveData( 'edit', postid, name, status );
            //console.log( 'SAVE TODO STATUS' + id + todo_name + status );
        }
        
        var saveExistingTodosEntry = ( id, postid, name, status ) => {
            this.saveData( 'edit', postid, name, status );
            $( '#todos_add_edit_entry_modal' ).foundation( 'close' );
            //console.log( 'SAVE EDIT TODO' + id + name + status );
        }
        
        var saveNewTodosEntry = ( postid, name, status ) => {
            this.saveData( 'new', postid, name, status );
        }
        
        var deletingExistingTodosEntry = ( id, postid, name, status ) => {
            this.saveData( 'delete', postid, name, status );
            $( '#todos_add_edit_entry_modal' ).foundation( 'close' );
            
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
			var save_text = $( '.modal_save_text' ).val();
            $( '#save_todos_entry ').text( save_text ); // Save
            $( '#save_todos_entry ').removeClass( 'delete' );            
        }
 
        
        // Add / Edit Entry modal open event...
        $( 'body' ).on( 'open.zf.reveal', '#todos_add_edit_entry_modal', function() {
            if ( todos_add_edit_modal_mode == 'edit' ) {
                $( '.edit', this ).show();
                $( '.add', this ).hide();
                $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
				var save_text = $( '.modal_save_text' ).val();
				//var delete_text = $( '.modal_delete_text' ).val();
            	$( '#save_entry ').text( save_text ); // Save
                $( '#save_entry ').removeClass( 'delete' );
                $( '.delete_entry_panel', this ).show();
                
            } else if ( todos_add_edit_modal_mode == 'add' ) {
                $( '.edit', this ).hide();
                $( '.add', this ).show();
                $( '.delete_entry_panel', this ).hide();
                $( '#entry_title_field' ).val( '' );
                
            }
            $( '#todos_entry_title_field' ).focus();
            //console.log( 'todos_add_edit_entry_modal open' );
        });
        

        // Add / Edit Entry modal close event...
        $( 'body' ).on( 'closed.zf.reveal', '#todos_add_edit_entry_modal', function() {
            $( '#todos_entry_title_field' ).val( '' );
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
			var save_text = $( '.modal_save_text' ).val();
			//var delete_text = $( '.modal_delete_text' ).val();
            $( '#save_todos_entry ').text( save_text ); // Save
            $( '#save_todos_entry ').removeClass( 'delete' );
            //console.log( 'todos_add_edit_entry_modal close' );
        });
        
        // Activity Type modal open event...
        $( 'body' ).on( 'open.zf.reveal', '#todos_entry_activity_modal', function() {
            //console.log( 'todos_entry_activity_modal open' );
        });
        
        // Activity Type modal close event...
        $( 'body' ).on( 'closed.zf.reveal', '#todos_entry_activity_modal', function() {
            $('#todos_types_slider').foundation( 'changeSlide', true, $( '.start-slide' ), 0 );
            //console.log( 'todos_entry_activity_modal close' );
        });
 
        
        // 'todos_add_edit_next', 'todos_add_edit_next' button clicks...
        $( 'body' ).on( 'click', '.todo_types_next', function( event ) {
            event.preventDefault();
        });
        
        
        $( 'body' ).on( 'change', '#delete_entry', function( event ) {
            if ( $( '#delete_entry' ).prop( 'checked' ) ) {
				//var save_text = $( '.modal_save_text' ).val();
				var delete_text = $( '.modal_delete_text' ).val();
            	$( '#save_todos_entry ').text( delete_text ); // DELETE
                $( '#save_todos_entry ').addClass( 'delete' );
                todos_add_edit_modal_mode = 'delete';
                //console.log( 'DELETE' );
            } else {
				var save_text = $( '.modal_save_text' ).val();
				//var delete_text = $( '.modal_delete_text' ).val();
            	$( '#save_todos_entry ').text( save_text ); // Save
                $( '#save_todos_entry ').removeClass( 'delete' );
                todos_add_edit_modal_mode = 'edit';
                //console.log( 'NOT DELETE' );
            }
            event.preventDefault();
        });
    
        

    },
    
    renderTodos() {
        // Render Todos...
        //console.log( 'renderTodos - start' );
        
        
        // Get any existing saved Todo entry data...
        this.loadData( 'load_live' );
        
        // Render entries...
        //this.renderTodoEntries();
        
        if ( this.aon_todos_entries === '' ) {
            $( '.todos_entry_add_edit' ).addClass( 'no_entries' );
        }
    },
    
    renderTodoEntries() {
        /*
         * Load / render existing entries to calendar...
         */
        //console.log( 'renderTodoEntries - start' );
        //console.table( this.aon_todos_entries );  
        
        // Remove any existing entries so that we don't re-render...
        $( '.todos li.todos_entry' ).remove();
        
        // Hide loading spinners...
        $( '.todos li.loading' ).remove();

        
   
        // Loop over entries array...
        var entry_count = 1;
        $.each( this.aon_todos_entries, function( index ) {
            //console.log( this.meta.aon_craft_todos_name );
            if ( typeof this.meta.aon_craft_todos_status === 'undefined' ) {
                var todo_status = 'active';
            } else if ( this.meta.aon_craft_todos_status === '' ) {
                var todo_status = 'active';
            } else {
                var todo_status = this.meta.aon_craft_todos_status;
            }
            // LIVE DATA VIA WP REST API RESPONSE...   
			var todo_name = this.meta.aon_craft_todos_name;
            var aon_todos_checkbox = '<button class="status ' + todo_status + '" data-todos-array-id="' + index + '" data-todos-postid="' + this.id + '">Mark "' + todo_name + '" as completed</button>';
            var aon_todos_entry_link = aon_todos_checkbox + '<a href="#edit_todos_entry" data-todos-array-id="' + index + '" data-todos-postid="' + this.id + '" data-todos-entry-status="' + todo_status + '" class="entry_' + entry_count + ' ' + todo_status + '" title="' + todo_name + '">' + todo_name + '</a>';
            
            if ( this.meta.aon_craft_todos_status == 'completed' ) {
                $( '.todos.completed' ).append( '<li class="todos_entry">' + aon_todos_entry_link + '</li>' );
                //$( '.todos.completed' ).append( aon_todos_entry_link_html );
            } else {
                $( '.todos.active' ).append( '<li class="todos_entry">' + aon_todos_entry_link + '</li>' );
                //$( '.todos.active' ).append( aon_todos_entry_link_html );
            }
            entry_count++;
            
            
            /* OLD VERSION FROM STATIC JSON DATA
            // Begin entry...           
            var aon_todos_checkbox = '<button class="status ' + this.status + '" data-todos-array-id="' + index + '">Mark "' + this.name + '" as completed</button>';
            var aon_todos_entry_link = aon_todos_checkbox + '<a href="#edit_todos_entry" data-todos-array-id="' + index + '" data-todos-postid="' + this.postid + '" data-todos-entry-status="' + this.status + '" class="entry_' + entry_count + ' ' + this.status + '" title="' + this.name + '">' + this.name + '</a>';
            if ( this.status == 'completed' ) {
                $( '.todos.completed' ).append( '<li class="todos_entry">' + aon_todos_entry_link + '</li>' );
            } else {
                $( '.todos.active' ).append( '<li class="todos_entry">' + aon_todos_entry_link + '</li>' );
            }
            entry_count++;*/
        });
        
        // If enable / disable Next button depending on whether entries exist...
        //todos_add_edit_next
        if ( !this.aon_todos_entries.length ) {
            $( '.todos_add_edit_next' ).addClass( 'disabled' );
        } else {
            $( '.todos_add_edit_next' ).removeClass( 'disabled' );
        }

    },
    
    renderNewTodoEntry( id, name, status ) {   
        var aon_todos_checkbox = '<button class="status ' + status + '" data-todos-array-id="000" data-todos-postid="' + id + '">Mark "' + name + '" as completed</button>';
        var aon_todos_entry_link = aon_todos_checkbox + '<a href="#edit_todos_entry" data-todos-array-id="' + id + '" data-todos-postid="' + id + '" data-todos-entry-status="' + status + '" class="entry_' + status + '" title="' + name + '">' + name + '</a>';

        if ( status == 'completed' ) {
            $( '.todos.completed' ).prepend( '<li class="todos_entry">' + aon_todos_entry_link + '</li>' );
        } else {
            $( '.todos.active' ).prepend( '<li class="todos_entry">' + aon_todos_entry_link + '</li>' );
        }
    },

    renderUpdateTodoEntry( id, name, status ) {
        $( 'button[data-todos-postid="' + id + '"]' ).text( 'Mark "' + name + '" as completed' );
        $( 'a[data-todos-postid="' + id + '"]' ).attr( 'title', name ).text( name );
        /*var aon_todos_checkbox = '<button class="status ' + status + '" data-todos-array-id="000" data-todos-postid="' + id + '">Mark "' + name + '" as completed</button>';
        var aon_todos_entry_link = aon_todos_checkbox + '<a href="#edit_todos_entry" data-todos-array-id="' + id + '" data-todos-postid="' + id + '" data-todos-entry-status="' + status + '" class="entry_' + status + '" title="' + name + '">' + name + '</a>';*/
        //$( '.todos li' ).remove();
        var target_li = $( 'button[data-todos-postid="' + id + '"]' ).parent();
        //console.log( 'target_li: ' + target_li );
        if ( status == 'completed' ) {
            target_li.children( 'button' ).removeClass( 'active' ).addClass( 'completed' );
            $( '.todos.completed' ).prepend( target_li );
        } else {
            target_li.children( 'button' ).addClass( 'active' ).removeClass( 'completed' );
            $( '.todos.active' ).prepend( target_li );
        }
    },
    
    renderDeleteTodoEntry( id ) {
        var target_li = $( 'button[data-todos-postid="' + id + '"]' ).parent();
        target_li.remove();
    },

    loadData( mode ) {
        /*
         * Set Data.
         * Either load existing data from backend or set default blank data...
         */
        var loadDataSuccessCallback = ( response ) => {
            this.aon_todos_entries = response;
            //console.log( 'this.aon_todos_entries' );
            //console.table( this.aon_todos_entries );
            this.renderTodoEntries();
        }
        
        // Load data from backend...
        if ( mode == 'load_live' ) {
            // Load User's ToDo from backend...
            //console.log( 'LOAD TODOS AJAX - START' );
            //var meta = { 'name' : name, 'status' : status };
            $.ajax({
                //url: wpApiSettings.root + 'wp/v2/todos/?per_page=100&author=' + wpApiSettings.current_user_id,
                url: wpApiSettings.root + 'wp/v2/todos/',
                method: 'GET',
                dataType: 'json',
                success: loadDataSuccessCallback,
                beforeSend: function ( xhr ) {
                    xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
                }
            }).done( function ( response ) {
                //console.log( 'LOAD TODOS Response: ' );
                //console.log( response );
                //this.aon_todos_entries = response;
                //console.log( 'POST-JSON.parse output: ' );
                //console.log( this.aon_todos_entries );
                //this.renderTodoEntries();
            });
            //console.log( 'LOAD TODOS AJAX - END' );

            //this.aon_todos_entries = JSON.parse( aon_todos_entries_json );
            //$( '.todos_add_edit_next' ).removeClass( 'disabled' );
            
            
        } else if ( mode == 'load_demo' ) {
            // Using temp JSON source for now...
            var aon_todos_entries_json = '[';
                aon_todos_entries_json += '{"postid":"17","aon_craft_todos_name":"Go buy some cheese","aon_craft_todos_status":"active"},';
                aon_todos_entries_json += '{"postid":"21","aon_craft_todos_name":"Learn how to fly","aon_craft_todos_status":"active"},';
                aon_todos_entries_json += '{"postid":"65","aon_craft_todos_name":"Arrange bank meeting","aon_craft_todos_status":"completed"},';
                aon_todos_entries_json += '{"postid":"43","aon_craft_todos_name":"Borrow book about milk","aon_craft_todos_status":"completed"}';
                aon_todos_entries_json += ']';

            this.aon_todos_entries = JSON.parse( aon_todos_entries_json );
            this.renderTodoEntries();
            //console.log( 'LOAD TODOS DEMO Response: ' );
            //console.log( this.aon_todos_entries );
            $( '.todos_add_edit_next' ).removeClass( 'disabled' );
            
        } else if ( mode == 'start' ) {
            
        }
        //console.log( 'this.aon_todos_entries:' );
        //console.table( this.aon_todos_entries );
        
        //console.log( aon_todos_entries_json );
        //var aon_todos_entries_as_string = JSON.stringify( this.aon_todos_entries );
        //console.log( aon_todos_entries_as_string );
    },
    
    saveData( mode, postid, name, status ) {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        
        var saveNewEntrySuccessCallback = ( response ) => {
            //console.log( 'ADD NEW SUCCESS - TRYING TO OPEN MODAL' );
            $( '#todos_add_edit_entry_modal' ).foundation( 'close' );
            if ( !$( 'section.todos_section').length > 0 ) { // Don't show confirmation modal on main Todos page
                $( '#todos_status_modal' ).foundation( 'open' );
            }
            //console.log( 'response.id, response.meta.aon_craft_todos_name, response.meta.aon_craft_todos_status: ' + response.meta.aon_craft_todos_name + ' - ' + response.meta.aon_craft_todos_status );
            this.renderNewTodoEntry( response.id, response.meta.aon_craft_todos_name, response.meta.aon_craft_todos_status );
        }
        
        var editEntrySuccessCallback = ( response ) => {
            //console.log( 'EDIT SUCCESS - TRYING TO OPEN MODAL' );
            $( '#todos_add_edit_entry_modal' ).foundation( 'close' );
            //$( '#todos_status_modal' ).foundation( 'open' );
            //console.log( 'response.id, response.meta.aon_craft_todos_name, response.meta.aon_craft_todos_status: ' + response.meta.aon_craft_todos_name + ' - ' + response.meta.aon_craft_todos_status );
            this.renderUpdateTodoEntry( response.id, response.meta.aon_craft_todos_name, response.meta.aon_craft_todos_status );
        }
        
        var deleteEntrySuccessCallback = ( response ) => {
            //console.log( 'DELETE SUCCESS' );
            //$( '#todos_add_edit_entry_modal' ).foundation( 'close' );
            //$( '#todos_status_modal' ).foundation( 'open' );
            //console.log( 'response.id, response.meta.aon_craft_todos_name, response.meta.aon_craft_todos_status: ' + response.meta.aon_craft_todos_name + ' - ' + response.meta.aon_craft_todos_status );
            this.renderDeleteTodoEntry( response.id );
        }
        
        // Saving ToDos done on individual basis, pushed via AJAX when added / edited / deleted.
        if ( mode == 'new' ) {
            // Push new ToDo to backend...
            //console.log( 'ADD TODO AJAX - START' );
            //console.log( 'aon_craft_todos_name: ' + name, '  -   aon_craft_todos_status: ' + status );
            var meta = { 'aon_craft_todos_name' : name, 'aon_craft_todos_status' : status };
            $.ajax({
                url: wpApiSettings.root + 'wp/v2/todos/',
                method: 'POST',
                success: saveNewEntrySuccessCallback,
                beforeSend: function ( xhr ) {
                    xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
                },
                data: {
                    'status' : 'publish',
                    'meta' : meta
                }
            }).done( function ( response ) {
                //$( '#todos_status_modal' ).foundation( 'open' );
                //console.log( 'ADD TODO Response: ' );
                //console.log( response );
            });
            //console.log( 'ADD TODO AJAX - END' );
            
            
        } else if ( mode == 'edit' ) {
            // Push updated ToDo to backend...
            //console.log( 'EDIT TODO AJAX - START' );
           // console.log( 'aon_craft_todos_name: ' + name, '  -   aon_craft_todos_status: ' + status );
            var meta = { 'aon_craft_todos_name' : name, 'aon_craft_todos_status' : status };
            $.ajax({
                url: wpApiSettings.root + 'wp/v2/todos/' + postid,
                method: 'POST',
                success: editEntrySuccessCallback,
                beforeSend: function ( xhr ) {
                    xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
                },
                data: {
                    'status' : 'publish',
                    'meta' : meta
                }
            }).done( function ( response ) {
                //$( '#todos_status_modal' ).foundation( 'open' );
                //console.log( 'EDIT TODO Response: ' );
                //console.log( response );
            });
            //console.log( 'EDIT TODO AJAX - END' );
            
        } else if ( mode == 'delete' ) {
            // Delete ToDo fron backend...
            //console.log( 'DELETE TODO AJAX - START' );
            //console.log( 'aon_craft_todos_name: ' + name, '  -   aon_craft_todos_status: ' + status );
            //var meta = { 'aon_craft_todos_name' : name, 'aon_craft_todos_status' : status };
            $.ajax({
                url: wpApiSettings.root + 'wp/v2/todos/' + postid,
                method: 'DELETE',
                success: deleteEntrySuccessCallback,
                beforeSend: function ( xhr ) {
                    xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
                }
            }).done( function ( response ) {
                //$( '#todos_status_modal' ).foundation( 'open' );
                //console.log( 'DELETE TODO Response: ' );
                //console.log( response );
            });
            //console.log( 'DELETE TODO AJAX - END' );
            
        }
        
        //var jsonDataString = JSON.stringify( this.aon_todos_entries );
        //console.log( 'jsonDataString: ' + jsonDataString );
        
        //console.log( 'Saving data via AJAX, saving the following:' );
        //console.table( this.aon_todos_entries );
    },
}